import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';


import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {

    return (
        <CustomTable
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Fecha Emisión',
                    dataIndex: 'fechaEmision',
                    key: 'fechaEmision',
                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumento',
                    key: 'serieDocumento',
                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'tipoComprobante',
                    key: 'tipoComprobante',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    render: (value, item) => (
                        <span style={{ color: item.diasVencido > 0 ? 'red' : '' }}>{value}</span>
                    )
                },
                {
                    title: 'Dias Vencidos',
                    dataIndex: 'diasVencido',
                    key: 'diasVencido',
                    render: (value) => (
                        <span style={{ color: value > 0 ? 'red' : '' }}>{value}</span>
                    )
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumento',
                    key: 'tipoDocumento',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Por Cobrar',
                    dataIndex: 'saldoSoles',
                    key: 'saldoSoles',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Conversión PEN',
                    dataIndex: 'converterSoles',
                    key: 'converterSoles',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
            ]}
        />
    );
}